import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductTypeStockFault } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

// The fault list held against a product type - what an operator can mark cloth down for
// at weaving and at final inspection.
@Injectable({
  providedIn: 'root',
})
export class ProductTypeStockFaultService extends TmsWebBaseEditCreateService<
  ProductTypeStockFault,
  ProductTypeStockFault
> {
  constructor() {
    super('ProductTypeStockFault', $localize`Fault`);
  }

  getByProductType(productTypeId: string): Observable<ProductTypeStockFault[]> {
    return this.httpService.get<ProductTypeStockFault[]>(`${this.apiUrl}/ProductType/${productTypeId}`);
  }
}
